// extracted by mini-css-extract-plugin
export default {"customIcon":"QRCodeModal_customIcon__fQP50","qrWrapper":"QRCodeModal_qrWrapper__Jearg"};